import { createClient } from '@supabase/supabase-js';
import { sharedSupabaseAuthStorage } from '@/lib/auth/session-cookie-storage';
import { createTimedFetch } from '@/lib/query-resilience';

// Use static property access so Turbopack/Next.js can inline NEXT_PUBLIC_* vars
// at build time. Dynamic access via requireEnv() won't be replaced in client bundles.
const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_DB_URL;
const supabaseAnonKey = process.env.NEXT_PUBLIC_SUPABASE_DB_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing NEXT_PUBLIC_SUPABASE_DB_URL or NEXT_PUBLIC_SUPABASE_DB_ANON_KEY');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    storage: sharedSupabaseAuthStorage,
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
  global: {
    // Without a timeout, a request stuck on a dead connection (mobile network
    // switch, laptop wake) hangs forever. Auth token refresh holds the auth
    // lock while it runs, so one hung refresh blocks getSession() for every
    // caller and the whole app silently stops loading data until a reload.
    fetch: createTimedFetch(),
  },
});

// Helper function to get current user
export const getCurrentUser = async () => {
  const { data: { user }, error } = await supabase.auth.getUser();
  if (error) return null;
  return user;
};